<div *ngFor="let field of Fields; let i = index" style="width: 100%;">
    <app-select [value]="formData.vars[field.nameTable]" [Field]="GetIndex(i)" (ValueSalida)="UpdateValue(field.nameTable, $event)"[multiple]="multiple"></app-select>
</div>